import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as actions from 'api'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { FiMoreHorizontal } from 'react-icons/fi'
import DateWithTooltip from 'components/DateWithTooltip'
import DataScreen from 'components/DataScreen'

class ArchivedEstimates extends Component {
  constructor(props) {
    super(props)
    this.dataScreen = React.createRef()
  }

  unarchiveEstimate = async estimate => {
    const unarchived = { ...estimate, archived: false }
    await this.props.updateEstimate(unarchived)
    if (this.dataScreen.current) {
      this.dataScreen.current.forceFetch()
    }
  }

  render() {
    const columns = [
      {
        header: 'Code',
        accessor: 'code'
      },
      {
        header: 'Client',
        accessor: 'client.name'
      },
      {
        header: 'Created By',
        accessor: 'createdBy.name.full'
      },
      {
        header: 'Created',
        render: item => {
          const { _id, createdAt } = item
          return <DateWithTooltip id={_id} date={createdAt} />
        }
      },
      {
        header: 'Options',
        render: estimate => (
          <UncontrolledDropdown>
            <DropdownToggle color="link">
              <FiMoreHorizontal size={24} color="white" />
            </DropdownToggle>
            <DropdownMenu right>
              <>
                <DropdownItem onClick={() => this.unarchiveEstimate(estimate)}>
                  Restore
                </DropdownItem>
              </>
            </DropdownMenu>
          </UncontrolledDropdown>
        )
      }
    ]

    return (
      <div className="container" style={{ marginTop: 20 }}>
        <h3
          style={{
            color: 'white',
            marginTop: 20,
            textAlign: 'center'
          }}
        >
          Archived Estimates
        </h3>
        <DataScreen
          ref={this.dataScreen}
          entity="Archived Estimate"
          url="/api/estimates/find?archived=true"
          columns={columns}
        />
      </div>
    )
  }
}

export default connect(null, actions)(ArchivedEstimates)
